module.exports = __webpack_public_path__ + "static/media/nps_up.909f48a3.svg";